"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioService = exports.SCENARIO_TRIGGER_TYPE = void 0;
const typedi_1 = require("typedi");
const emitter_1 = require("./emitter");
/**
 * Тип обработки
 */
var SCENARIO_TRIGGER_TYPE;
(function (SCENARIO_TRIGGER_TYPE) {
    SCENARIO_TRIGGER_TYPE["ALL"] = "all";
})(SCENARIO_TRIGGER_TYPE = exports.SCENARIO_TRIGGER_TYPE || (exports.SCENARIO_TRIGGER_TYPE = {}));
/**
 * Сервис условий
 */
let ScenarioService = class ScenarioService {
    /**
     * Конструктор
     */
    constructor() {
        this.eventEmitter = typedi_1.Container.get(emitter_1.EventEmitter);
    }
    /**
     * Создает условие
     */
    createScenario(awaitingEvents, triggerType, cancellationEvents, successCallback, cancelCallback) {
        const result = awaitingEvents.reduce((carry, event) => {
            carry[event] = false;
            return carry;
        }, {});
        const isAll = () => {
            return Object.keys(result).map((v) => result[v]).every(Boolean);
        };
        const hasTriggeredCancel = () => {
            const countSucceed = Object.keys(result).map((v) => result[v]).filter(Boolean).length;
            const countCancellation = cancellationEvents.length;
            if (countSucceed !== countCancellation) {
                return false;
            }
            return cancellationEvents.every((event) => result[event]);
        };
        const succeed = (event) => () => {
            result[event] = true;
            if (hasTriggeredCancel()) {
                clear();
                cancelCallback && cancelCallback();
            }
            if (isAll()) {
                clear();
                successCallback();
            }
        };
        const callbacks = awaitingEvents.reduce((carry, eventName) => {
            carry[eventName] = succeed(eventName);
            return carry;
        }, {});
        const clear = () => {
            awaitingEvents.map((event) => {
                this.eventEmitter.off(event, callbacks[event]);
            });
        };
        awaitingEvents.map((event) => {
            this.eventEmitter.on(event, callbacks[event]);
        });
    }
};
ScenarioService = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], ScenarioService);
exports.ScenarioService = ScenarioService;
